import React, { Component } from 'react';

export default class AvisoAtacado extends Component {
    render(){
        return (
            <div className="AvisoAtacado">
                <div className="container flex vertical flex-center">
                    <h2>
                        PARA COMPRAS NO ATACADO, CAIXA FECHADA E OUTRAS CONDICOES, LIGUE: (11) 4372-7073
                    </h2>
                </div>
            </div>
        )
    }
}